import { NoteMediaKind } from "@/store/note";
import { MDSIconKind } from "@/mds";

export enum MediaKindsFacetFilterItemKind {
  Label = "label",
  MediaKind = "media-kind",
}

export type MediaKindsFacetFilterItem =
  | {
      id: string;
      kind: MediaKindsFacetFilterItemKind.Label;
      isSelected: boolean;
      label: string;
    }
  | {
      id: string;
      kind: MediaKindsFacetFilterItemKind.MediaKind;
      isSelected: boolean;
      label: string;
      data: {
        mediaKind: NoteMediaKind;
        icon: MDSIconKind;
      };
    };
